module.exports = __webpack_public_path__ + "img/spring_03.6f9e27df.png";